/** Budget pool arithmetic the screen shows. */

import { usd } from './money'

/** How many hours late Google reports cost. The campaigns keep spending while
 *  the figure the console sums is that old, so a pool can pass its total by
 *  about (daily budgets of the running members) × (lag / 24) before the sync
 *  sees it and pauses them. Six hours is the usual delay seen on this account;
 *  raise it if the overshoot proves larger. */
export const COST_REPORT_LAG_HOURS = 6

/** What a pool can spend past its total because of the report lag, in dollars. */
export function overshootUSD(dailyBudgetSum: number): number {
  if (!(dailyBudgetSum > 0)) return 0
  return (dailyBudgetSum * COST_REPORT_LAG_HOURS) / 24
}

/** "$30" for a whole amount, "$12.40" otherwise: a total is usually round and
 *  reads better without the cents beside the spent figure. */
export function usdTotal(v: number): string {
  return Number.isInteger(v) ? usd(v).replace(/\.00$/, '') : usd(v)
}

/** The share of the total spent, 0 to 100. */
export function poolPercent(spent: number, total: number): number {
  if (!(total > 0)) return 0
  return Math.max(0, Math.min(100, (spent / total) * 100))
}

/** "10. 22.부터 11. 4.까지", "10. 22.부터 · 끝 없음" from YYYY-MM-DD days. */
export function poolPeriod(start: string, end: string | null): string {
  const md = (d: string) => {
    const [, m, day] = d.split('-')
    return `${Number(m)}. ${Number(day)}.`
  }
  return end ? `${md(start)}부터 ${md(end)}까지` : `${md(start)}부터 · 끝 없음`
}
